import { useEffect, useState } from 'react';

export function useImagesLoaded(images: readonly string[]) {
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setImagesLoaded(false);

    const waitForImage = (src: string) =>
      new Promise<void>((resolve) => {
        const image = new Image();
        image.onload = () => resolve();
        image.onerror = () => resolve();
        image.src = src;
        if (image.complete) resolve();
        else {
          image.decode?.().then(resolve, () => {
            if (image.complete) resolve();
          });
        }
      });

    Promise.all(images.map(waitForImage)).then(() => {
      if (!cancelled) setImagesLoaded(true);
    });

    return () => {
      cancelled = true;
    };
  }, [images]);

  return imagesLoaded;
}
